import { render } from "./DentalTourismPageSmallScreen.vue?vue&type=template&id=709e9321"
import script from "./DentalTourismPageSmallScreen.vue?vue&type=script&lang=js"
export * from "./DentalTourismPageSmallScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__